import React from "react";
import { Route, Routes } from "react-router-dom";
import Header from "../components/Header";
import CommunityLogin from "../views/PreLogin/CommunityLogin";

const PreLoginRoutes = (props) => {
  return (
    <>
      <Routes>
        <Route path="*" element={<CommunityLogin onChange={props.onChange} />} />
      </Routes>
    </>
  );
};

export default PreLoginRoutes;
